import { createSlice } from '@reduxjs/toolkit';

const initialTrashState = {
	listLoading: false,
	actionsLoading: false,
	totalCount: 0,
	entities: null,
	lastError: null,
};

export const callTypes = {
	list: 'list',
	action: 'action',
};

export const trashSlice = createSlice({
	name: 'trash',
	initialState: initialTrashState,
	reducers: {
		catchError: (state, action) => {
			state.error = action.payload.error;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = false;
			} else {
				state.actionsLoading = false;
			}
		},

		startCall: (state, action) => {
			state.error = null;
			if (action.payload.callType === callTypes.list) {
				state.listLoading = true;
			} else {
				state.actionsLoading = true;
			}
		},

		// findVoids
		trashsFetched: (state, action) => {
			const { total_items, items } = action.payload;
			state.listLoading = false;
			state.error = null;
			state.entities = items;
			state.totalCount = total_items;
		},

		// Set to default state actionLoading & error
		trashReload: (state, action) => {
			state.actionsLoading = false;
			state.listLoading = false;
			state.error = null;
		},

	},
});

